import React from "react";

import ContentSection from "../ContentSection";
import Carousel from "../Carousel";
import useWindowSize from "../../../hooks/useWindowSize";
import * as S from './ContentWithMoreThanOneVideo.Style'

import { ReactComponent as Youtoba } from "../../../assets/images/habitacional/social-youtube.svg";


const ContentWithMoreThanOneVideo = ({ slideVideos }) => {
    const { width } = useWindowSize();
    const isDesktop = width >= 768;

    const slides = slideVideos.map((video) => (
        <S.VideoSlideCard id={video.id}>
            <iframe
                src={video.link}
                title="YouTube video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
            <S.Title>{video.title}</S.Title>
            <S.Paragraph>{video.description}</S.Paragraph>
            <S.Link href={video.link} target="_blank" rel="noreferrer">
                <Youtoba />
                Assistir no Youtube
            </S.Link>
        </S.VideoSlideCard>
    ));

    return (
        <ContentSection
            title="Fique por dentro!"
            description="Tudo o que você precisa saber antes e depois de acionar o Seguro Habitacional."
        >
            {!isDesktop && <Carousel>{slides}</Carousel>}
            <S.Container>{slides}</S.Container>
        </ContentSection>
    );
};

export default ContentWithMoreThanOneVideo;
